/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

import { ObservableCollection } from '../util/observable-collection.util';
import { toEntries } from './to-entries.helper';

export function forEach<K extends string | number, V>(
  source: Iterable<V> | Map<K, V> | ObservableCollection<K, V> | object,
  callback: (item: V, key?: K, done?: (result?: any) => void) => void
): any {
  if (!source) {
    return;
  }

  let done: boolean = false;
  let doneResult: any;
  const doneCallback = (result?: any) => {
    doneResult = result;
    done = true;
  };

  for (const entry of toEntries(source)) {
    const key = entry[0];
    const value = entry[1];
    callback(value, key, doneCallback);
    if (done) {
      return doneResult;
    }
  }
}
